import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useProductsContext } from '../../context/products_context';
import { IoMdClose } from 'react-icons/io';
import Loading from '../Loading';
const PricePopup = () => {
  const [metalPrices, setMetalPrices] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const {closePricePopup}=useProductsContext()
  const [showGold, setshowGold]=useState(true)


  useEffect(() => {
    const getData = async () => {
      setIsLoading(true);
      let res = await axios.get(
        `${process.env.REACT_APP_BACKEND_HOST}/api/metal-price`
      );
      setMetalPrices(res.data.data);
      setIsLoading(false);
    };
    getData();
  }, []);
  let date;
  const now = new Date();
  const year=now.getFullYear()
  const month=now.getMonth()
  date=now.getDate()
  
  return (
    <div className='fixed inset-0 bg-[rgba(0,0,0,0.5)] bg-opacity-40 flex items-center justify-center z-50'>
      <div className='bg-white w-full max-w-md rounded-xl shadow-lg relative'>
        {!isLoading && (
          <>
            <div className='w-full flex justify-between items-center mb-3 bg-[#010535] text-white p-4 rounded-t-xl'>
              <h1 className=''>Today's gold/silver prices</h1>
              <div
                className='flex justify-end  rounded-md items-end'
                onClick={() => closePricePopup()}
              >
                <IoMdClose className='w-6 h-6' />
              </div>
            </div>

            {/* Buttons */}

            <div className='flex flex-col gap-3 py-3 px-6'>
              <div className='flex flex-col gap-3'>
                <div className='flex w-full justify-between items-center gap-1'>
                  <h1 className='text-[#D3A143]'>Gold</h1>
                  <p className='flex gap-1'>
                    Updated on:-{' '}
                    {metalPrices?.find((e) => e.id == 5)?.updatedAt &&
                      new Date(metalPrices.find((e) => e.id == 5).updatedAt)
                        .toLocaleString('en-GB', {
                          timeZone: 'Asia/Kolkata',
                          day: '2-digit',
                          month: '2-digit',
                          year: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit',
                          hour12: true,
                        })
                        .replace(',', ';')
                        .toLowerCase()}
                  </p>
                </div>
                <ul className='list-disc list-inside text-black gap-8'>
                  <li className='bg-[#F8F1E3] flex justify-between p-2 w-full rounded-md mb-2'>
                    Gold 24K Price
                    <span className='text-[#D3A143]'>
                      {metalPrices?.find((e) => e.id == 5)?.pricePerGram}/gm
                    </span>
                  </li>
                  <li className='bg-[#F8F1E3] flex justify-between p-2 w-full rounded-md mb-2'>
                    Gold 22K Price
                    <span className='text-[#D3A143]'>
                      {metalPrices?.find((e) => e.id == 6)?.pricePerGram}/gm
                    </span>
                  </li>
                  <li className='bg-[#F8F1E3] flex justify-between p-2 w-full rounded-md mb-2'>
                    Gold 18K Price
                    <span className='text-[#D3A143]'>
                      {metalPrices?.find((e) => e.id == 7)?.pricePerGram}/gm
                    </span>
                  </li>
                </ul>
              </div>
              <div className='flex flex-col gap-2'>
                <div className='flex w-full justify-between items-center'>
                  <h1 className='text-black'>Silver</h1>
                  <p className='flex gap-1'>
                    Updated on:-{' '}
                    {metalPrices?.find((e) => e.id === 8)?.updatedAt &&
                      new Date(metalPrices.find((e) => e.id === 8).updatedAt)
                        .toLocaleString('en-GB', {
                          timeZone: 'Asia/Kolkata',
                          day: '2-digit',
                          month: '2-digit',
                          year: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit',
                          hour12: true,
                        })
                        .replace(',', ';')
                        .toLowerCase()}
                  </p>
                </div>
                <ul className='list-disc list-inside text-black'>
                  <li className='bg-[#F0EFEF] flex justify-between p-2 w-full rounded-md mb-2'>
                    Pure silver
                    <span className='text-black'>
                      {metalPrices?.find((e) => e.id == 8)?.pricePerGram}/gm
                    </span>
                  </li>{' '}
                  <li className='bg-[#F0EFEF] flex justify-between p-2 w-full rounded-md mb-2'>
                    Silver
                    <span className='text-black'>
                      {metalPrices?.find((e) => e.id == 11)?.pricePerGram}/gm
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </>
        )}
        {isLoading && <Loading />}
      </div>
    </div>
  );
};
export default PricePopup;
